"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateForDevMode = void 0;
var constants_1 = require("../constants");
function validateForDevMode(openerOptions, showOptions) {
    if (process.env.NODE_ENV === 'development') {
        var isOpenerOptionsValid = require('./opener-options-validator').isOpenerOptionsValid;
        var isShowOptionsValid = require('./show-options/show-options-validator').isShowOptionsValid;
        if (!isShowOptionsValid(showOptions)) {
            console.error(isShowOptionsValid.errors);
            return {
                type: constants_1.OpenerEventTypes.Error,
                showOptions: showOptions,
                error: new Error('Cannot show question because `showOptions` argument is invalid'),
            };
        }
        if (!isOpenerOptionsValid(openerOptions)) {
            console.error(isOpenerOptionsValid.errors);
            return {
                type: constants_1.OpenerEventTypes.Error,
                showOptions: showOptions,
                error: new Error('Cannot show question because UserFeedbackOpener was misconfigured.'),
            };
        }
    }
    return;
}
exports.validateForDevMode = validateForDevMode;
//# sourceMappingURL=dev-mode-validation.js.map